import React, { useState, useEffect, useRef } from "react";
import classes from "./DakshPage.module.css";
import Daksh_video from "../assets/Daksh_video.mp4";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { server_url } from "../index";

const modules = [
  {
    tag: "01 // FILTER",
    heading: "CUT THROUGH THE AI NOISE",
    text: (
      <>
        Our GenAI Noise Filter validates real skills through rapid, contextual
        AI interviews—eliminating{" "}
        <span className={classes.highlightWhite}>"resume hacking"</span> and
        industrial-scale generic polish.
      </>
    ),
  },
  {
    tag: "02 // PREDICT",
    heading: "PREDICT SUCCESS",
    text: (
      <>
        Move beyond basic interviews with agentic assessments that objectively
        measure conceptual, applicative, and behavioral skills in a{" "}
        <span className={classes.highlightWhite}>real-world environment</span>.
      </>
    ),
  },
  {
    tag: "03 // OPTIMIZE",
    heading: "RECLAIM YOUR TIME",
    text: (
      <>
        Let AI agents handle the heavy lifting of screening, giving you a{" "}
        <span className={classes.highlightWhite}>unified dashboard</span> to
        make final decisions without the fatigue of manual labor.
      </>
    ),
  },
];

const DakshPage = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [email, setEmail] = useState("");
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);

  const videoRef = useRef(null);
  const betaRef = useRef(null);
  const urbanRef = useRef(null);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.play().catch(() => {});
    }
  }, []);

  const toggleMute = () => {
    if (!videoRef.current) return;
    const newMute = !isMuted;
    setIsMuted(newMute);
    videoRef.current.muted = newMute;
  };

  const togglePlay = () => {
    if (!videoRef.current) return;

    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleJoin = () => {
    if (!email) {
      alert("Please enter a valid email!");
      return;
    }
    alert(`Joined waitlist with: ${email}`);
    setEmail("");
  };

  const scrollToBeta = () => {
    betaRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToUrban = () => {
    urbanRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const [formData, setFormData] = useState({
    your_email: "",
    what_best_describes_you: "",
    what_are_you_hoping_to_achieve: "",
    tell_us_more: "",
  });

  const [message, setMessage] = useState("");
  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  // Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Company email format only
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(formData.your_email)) {
      toast.error(
        "Please enter a valid company email (example: name@company.com)",
      );
      return;
    }

    // Optional: Block free domains like Gmail
    const blockedDomains = [
      // Global Free Email Providers
      "gmail.com",
      "googlemail.com",
      "outlook.com",
      "hotmail.com",
      "live.com",
      "msn.com",
      "yahoo.com",
      "ymail.com",
      "aol.com",
      "icloud.com",
      "me.com",
      "mac.com",
      "proton.me",
      "protonmail.com",
      "pm.me",
      "zoho.com",
      "gmx.com",
      "gmx.net",
      "mail.com",
      "yandex.com",
      "yandex.ru",
      "tutanota.com",

      "startmail.com",
      "mailbox.org",
      "posteo.de",

      // India Specific
      "rediffmail.com",
      "rediff.com",
      "indiatimes.com",

      // International Providers
      "web.de",
      "libero.it",
      "laposte.net",
      "orange.fr",
      "t-online.de",
      "163.com",
      "126.com",
      "qq.com",
      "sina.com",
    ];

    const domain = formData.your_email.split("@")[1];

    if (blockedDomains.includes(domain)) {
      toast.error("Please use your official email address.");
      return;
    }

    try {
      const response = await fetch(`${server_url}/api/daskform`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        toast.success("Form submitted successfully!");
        setFormData({
          your_email: "",
          what_best_describes_you: "",
          what_are_you_hoping_to_achieve: "",
          tell_us_more: "",
        });
      } else {
        toast.error(data.error);
      }
    } catch (error) {
      toast.error("Server error. Please try again.");
    }
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <div className={classes["fullcontainer"]}>
          <Header onTechClick={scrollToUrban} onAccessClick={scrollToBeta} />

          <div className={classes.hero}>
            <div className={classes.left}>
              <p className={classes.system}>
                // SYSTEM STATUS: DISRUPTING RECRUITMENT
              </p>

              {/* <div className={classes.headingBlock}>
                <h1 className={classes.title}>STOP</h1>
                <h1 className={classes.title}>GUESSING.</h1>
                <h1 className={classes.subtitle}>
                  <span>HIRE WITH</span>
                </h1>
                <h1 className={classes.title}>PRECISION.</h1>
              </div> */}

              <div className={classes.headingBlock}>
                <h1 className={classes.headingtitle}>HIRE</h1>
                <h1 className={classes.headingtitle}>WITH</h1>
                <h1 className={classes.subtitle7}>
                  <span className={classes.subtitle7}>CONFIDENCE</span>
                </h1>
                <h1 className={classes.headingtitle}>EVERY TIME.</h1>
              </div>

              <p className={classes.description}>
                Resumes tell you what they did. <b>Daksh</b> tells you if
                they'll succeed. Our platform isolates the <i>Success DNA</i>{" "}
                within the noise of modern applications.
              </p>

              <div className={classes.bottomRow}>
                <button className={classes.requestBtn} onClick={scrollToBeta}>
                  REQUEST EARLY ACCESS
                </button>

                <div className={classes.protocol}>
                  <span className={classes.protocolv}>PROTOCOL V4.0</span>
                  <p className={classes.activebeta}>ACTIVE BETA TESTING</p>
                </div>
              </div>
            </div>

            <div className={classes.videoWrapper}>
              <video
                ref={videoRef}
                src={Daksh_video}
                autoPlay
                loop
                muted={isMuted}
                playsInline
                className={classes.heroVideo}
                onClick={togglePlay}
              />

              {!isPlaying && (
                <div className={classes.playOverlay} onClick={togglePlay}>
                  ▶
                </div>
              )}

              <button className={classes.muteBtn} onClick={toggleMute}>
                {isMuted ? "🔇" : "🔊"}
              </button>
            </div>
          </div>

          <section ref={urbanRef} className={classes.urbanSection}>
            <div className={classes.urbanHeader}>
              <h2 className={classes.urbanTitle}>
                {/* THE <span>URBAN</span> <br /> INFRASTRUCTURE */}
                HOW<span className={classes.subtitle6}> DAKSH</span> <br />
                WORKS
              </h2>

              <p className={classes.urbanSubtitle}>
                Enterprise-grade AI that elevates your hiring process from end
                to end.
              </p>

              <div className={classes.coreTag}>[ CORE MODULES ]</div>
            </div>

            <div className={classes.urbanGrid}>
              {modules.map((item, index) => (
                <div
                  key={index}
                  className={`${classes.urbanCard} ${
                    index === 1 ? classes.urbanActive : ""
                  }`}
                >
                  <span className={classes.urbanStep}>{item.tag}</span>
                  <h3>{item.heading}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </section>

          <section ref={betaRef} className={classes.betaSection}>
            <div className={classes.betaContainer}>
              <h1 className={classes.betaTitle}>
                INITIALIZE <span className={classes.highlight7}>BETA</span>{" "}
                ACCESS
              </h1>

              <p className={classes.betaSubtitle}>
                Be the first to map the{" "}
                <span className={classes.italic}>"Success DNA"</span> of your
                next high-performer. Accepting a limited number of strategic
                partners.
              </p>

              <div className={classes["formwrapper"]}>
                <div className={classes["formcontainer"]}>
                  <div className={classes["formCard"]}>
                    <h1 className={classes.title}>
                      LET’S <span className={classes.highlight}>CONNECT</span>
                    </h1>

                    <p className={classes.subtitle}>
                      Tell us about your hiring needs and we’ll show you Daksh
                      can help you find the right talent.
                    </p>

                    <form className={classes.form} onSubmit={handleSubmit}>
                      <label className={classes.label}>// YOUR_EMAIL</label>
                      <input
                        type="email"
                        name="your_email"
                        value={formData.your_email}
                        onChange={(e) => {
                          if (e.target.value.includes(" ")) return;
                          handleChange(e);
                        }}
                        placeholder="you@gmail.com"
                        className={classes.input}
                        required
                      />

                      <label className={classes.label}>
                        // WHAT_BEST_DESCRIBES_YOU?
                      </label>
                      <input
                        type="text"
                        name="what_best_describes_you"
                        value={formData.what_best_describes_you}
                        onChange={handleChange}
                        placeholder="Enter your role..."
                        className={classes.input}
                        required
                      />

                      <label className={classes.label}>
                        // WHAT_ARE_YOU_HOPING_TO_ACHIEVE?
                      </label>
                      <input
                        type="text"
                        name="what_are_you_hoping_to_achieve"
                        value={formData.what_are_you_hoping_to_achieve}
                        onChange={handleChange}
                        placeholder="Enter your goal..."
                        className={classes.input}
                        required
                      />

                      <label className={classes.label}>
                        // TELL_US_MORE (OPTIONAL)
                      </label>
                      <textarea
                        name="tell_us_more"
                        value={formData.tell_us_more}
                        onChange={handleChange}
                        placeholder="Any specific challenges or questions..."
                        className={classes.textarea}
                      ></textarea>

                      <button type="submit" className={classes.submitBtn}>
                        GET IN TOUCH
                      </button>

                      {message && <p>{message}</p>}
                    </form>
                    <ToastContainer
                      position="top-right"
                      autoClose={3000}
                      hideProgressBar={false}
                      closeOnClick
                      pauseOnHover
                      draggable
                      theme="dark"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default DakshPage;
